import RecombeeClient from "@MAIN/modules/RecombeeClient";
import AnalyticsAbstract from "@MAIN/modules/Analytics/Abstract";
import AnalyticsYandex from "@MAIN/modules/Analytics/Yandex";
import AnalyticsFacebook from './Analytics/Facebook'
import AnalyticsECommerce from './Analytics/ECommerce'
import AnalyticsGoogle from './Analytics/GTag'


function loadRetailCrm() {
  if (!process.env.MIX_RETAILCRM_COLLECTOR) {
    return
  }

  (function(_,r,e,t,a,i,l){_['retailCRMObject']=a;_[a]=_[a]||function(){(_[a].q=_[a].q||[]).push(arguments)};
    _[a].l=1*new Date();l=r.getElementsByTagName(e)[0];i=r.createElement(e);i.async=!0;i.src=t;l.parentNode.insertBefore(i,l)})
  (global,document,'script','https://collector.retailcrm.pro/w.js','_rc')

  global._rc('create', process.env.MIX_RETAILCRM_COLLECTOR)
  global._rc('send', 'pageView')
}


class Analytics extends AnalyticsAbstract {
  constructor() {
    super()

    this.yandex = new AnalyticsYandex()
    this.facebook = new AnalyticsFacebook()
    this.google = new AnalyticsGoogle()
    this.ecommerce = new AnalyticsECommerce()
    this.recombee = RecombeeClient

    loadRetailCrm()
  }

  addToCartButtonClicked(product) {
    this.log(product)
    this.recombee.AddCartAddition(product.id)
    this.yandex.reachGoal('addToCart', { order_price: product.price, currency : 'RUB' })
    this.ecommerce.add(product)
    this.facebook.addToCart(product)
  }

  addToCart(product, quantity = 1) {
    this.ecommerce.add(product, quantity)
  }
  removeFromCart(product, quantity = 1) {
    this.ecommerce.remove(product, quantity)
  }

  search() {
    this.facebook.Search()
  }

  wishlist(product_id) {
    RecombeeClient.AddBookmark(product_id)
    this.facebook.AddToWishlist()
  }

  viewContent(product) {
    this.ecommerce.detail(product)
    this.facebook.ViewContent(product)
    this.recombee.AddDetailView(product.id)
  }

  createLead(goal) {
    this.yandex.reachGoal(goal)
    this.facebook.TrackLead()
  }

  initiateCheckout() {
    this.yandex.reachGoal('InitiateCheckout')
    this.facebook.InitiateCheckout()
    this.ecommerce.checkout_progress(2)
  }

  orderCreated(order) {
    this.yandex.reachGoal('order')
    this.facebook.CompleteRegistration(order.total_price)
    order.items.forEach(item => {
      this.recombee.AddPurchase(item.id)
    })

    order.total_price = 0
    order.delivery_price = 0
    this.ecommerce.transaction(order)
  }

  orderPaid(order) {
    this.facebook.Purchase(order)
    this.ecommerce.transaction(order)
  }
}

const A = new Analytics()
export default A
